import React, { Component } from 'react';
import { SubmissionError } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { getDiffInMinutes } from 'utils/misc';

import { createSequence, updateSequence } from 'redux/actions/sequenceActions';
import SequenceDetailsForm from './SequenceDetailsForm';


class SequenceDetails extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    createSequence: PropTypes.func.isRequired,
    updateSequence: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired,
    submitBtnText: PropTypes.string,
    schedules: PropTypes.shape({
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      results: PropTypes.array,
    }).isRequired,
    sequence: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
    }).isRequired,
    campaign: PropTypes.shape({
      id: PropTypes.number,
      account: PropTypes.number,
      name: PropTypes.string,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
    }).isRequired,
    initialValues: PropTypes.shape({
      name: PropTypes.string,
      launch_date: PropTypes.instanceOf(Date),
      schedule: PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.number,
      }),
    }),
    handleChangeModalSize: PropTypes.func,
  };

  static defaultProps = {
    submitBtnText: 'Next',
    initialValues: {},
    handleChangeModalSize: () => {},
  };

  componentDidMount() {
    this.props.handleChangeModalSize('large');
  }

  async onSubmit(formData) {
    const { campaign, sequence, onSubmit } = this.props;

    let { schedule } = formData;
    schedule = this.props.schedules.results.find(sch => sch.id === schedule.value);

    const diffInMinutes = getDiffInMinutes(schedule.timezone);
    const launchDate = new Date(moment(formData.launch_date).add(diffInMinutes, 'minutes'));
    try {
      if (!sequence.id) {
        await this.props.createSequence({
          name: formData.name,
          campaign: campaign.id,
          status: false,
          launch_date: launchDate,
          schedule: formData.schedule.value,
          validate_contacts: formData.validate_contacts,
          send_to_risky: formData.send_to_risky,
        });
      } else {
        await this.props.updateSequence(sequence.id, {
          name: formData.name,
          campaign: campaign.id,
          launch_date: launchDate,
          schedule: formData.schedule.value,
          validate_contacts: formData.validate_contacts,
          send_to_risky: formData.send_to_risky,
        });
      }
      onSubmit();
    } catch (error) {
      if (error.errors) {
        throw new SubmissionError(error.errors);
      }
    }
  }

  render() {
    const { toggleModal, submitBtnText } = this.props;
    return (
      <SequenceDetailsForm
        toggleModal={toggleModal}
        onSubmit={formData => this.onSubmit(formData)}
        submitBtnText={submitBtnText}
      />
    );
  }
}

export default compose(connect(
  state => ({
    sequence: state.sequence,
    campaign: state.campaign,
    schedules: state.schedules,
  }),
  { createSequence, updateSequence },
))(SequenceDetails);
